import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import { DynamicBackgroundFade } from '../styles/helpers/animations';

class DynamicBackgroundContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundLayers: [this.props.dynamicColor]
    };
    this.renderBackgroundLayers = this.renderBackgroundLayers.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.dynamicColor !== nextProps.dynamicColor) {
      this.addBackgroundLayer(nextProps.dynamicColor);
    }
  }

  addBackgroundLayer(color) {
    this.setState({
      backgroundLayers: [color]
    });
  }

  renderBackgroundLayers() {
    return this.state.backgroundLayers.map(item => {
      if (Array.isArray(item)) {
        return (
          <DynamicBackgroundFade key={item}>
            <DynamicBackground active={this.props.active} backgroundGradient={item} opacity={this.props.opacity} />
          </DynamicBackgroundFade>
        );
      }

      return (
        <DynamicBackgroundFade key={item}>
          <DynamicBackground active={this.props.active} backgroundColor={item} opacity={this.props.opacity} />
        </DynamicBackgroundFade>
      );
    });
  }

  render() {
    const backgroundLayers = this.renderBackgroundLayers();

    return (
      <RootContainer backgroundColor={this.props.staticColor}>
        <TransitionGroup>{backgroundLayers}</TransitionGroup>
        {this.props.children}
      </RootContainer>
    );
  }
}

const RootContainer = styled.div`
  position: relative;
  background-color: ${props => props.backgroundColor};
`;

const DynamicBackground = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: opacity 400ms linear;
  opacity: ${props => (props.active ? 1 : 0)};
  
  ${props =>
    props.backgroundColor &&
    css`
      background-color: ${`${props.backgroundColor}${props.opacity ? props.opacity : ''}`};
    `}
  
  ${props =>
    Array.isArray(props.backgroundGradient) &&
    props.backgroundGradient.length === 2 &&
    css`
      background: linear-gradient(
        135deg,
        ${`${props.backgroundGradient[0]}55`} 0%,
        ${`${props.backgroundGradient[1]}55`} 100%
      );
    `}
  
  ${props =>
    Array.isArray(props.backgroundGradient) &&
    props.backgroundGradient.length >= 3 &&
    css`
      background: linear-gradient(
        135deg,
        ${`${props.backgroundGradient[0]}55`} 0%,
        ${`${props.backgroundGradient[1]}55`} 50%,
        ${`${props.backgroundGradient[2]}55`} 100%
      );
    `}
`;

DynamicBackgroundContainer.defaultProps = {
  staticColor: null,
  dynamicColor: null,
  active: false,
  opacity: null
};

DynamicBackgroundContainer.propTypes = {
  staticColor: PropTypes.string,
  dynamicColor: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  active: PropTypes.bool,
  opacity: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default DynamicBackgroundContainer;



// WEBPACK FOOTER //
// ./src/components/DynamicBackgroundContainer.js